import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './index.less';
import UploadBanner from './components/UploadBanner/UploadBanner';
import moment from 'moment';
import {Button, Form, Input,Select,Divider,DatePicker,Checkbox,Collapse,Switch,Spin, Space} from 'antd';
import { updateSuccessMessage, updateWarningMessage } from '@/redux/reducer/common';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import { IDomEditor, IEditorConfig, IToolbarConfig } from '@wangeditor/editor';
import '@wangeditor/editor/dist/css/style.css';
import IF from '@/components/IF';
import { RootState } from '@reduxjs/toolkit';
import {IAgriAlertTranslateResModel, TemplateEnumType} from '@/util/Request/agrialert/responseType';
import TemplatePreview from '../template-preview';
import { updateTemplateType,updatePreviewDetails, updateAllBanner, updateSuccessOpen,updateTempOrSubName,updateFileContent,
    updateTranslateData} from '@/redux/reducer/agrialertTemplate';
import {
    getTimezoneList,
    getTemplateOptions,
    getAllBanners,
    addTemplate,
    saveTemplate,
    checkIsValidTempOrSubName,
    addSubscription,
    saveSubscription,
    deleteTemplate,
    updateReportNextSendTime,
    uploadReportBanner,
    getAgriAlertTranslateValue
} from '@/util/Request/agrialert';
import {
    ITimezoneListResModel,
    ITemplateOptionsResModel,
    IgetAllBannersResModel,
    locationListModel,
    deleteTemplateReqModel,
    IAgronomicRedommedationModel,
    IHistoricalChartsModel,
    IForecastChartOrTableModel
} from '@/util/Request/agrialert/requestType';
const { Panel } = Collapse;
import AgriAlertLocation from './components/agriAlertLocation';
import AgronomicRecommendations from './components/agronomicRecommendations';
import HistoricalChartSelect from './components/historicalChartSelect';
import ForecastChartSelect from './components/forecastSelect';
import ForecastTableSelect from './components/forecastSelect';
import {IActiveKeyAndCustomClassType} from './init';
import { useImmer } from 'use-immer';
import { AgronomicTypeEnum, TimePeriodEnum } from './components/agronomicRecommendations/initTypeAndFunc';
import { ChartsOrTablesEnum } from '../../template-management';

const TemplateEdit = ()=>{
    const dispatch = useDispatch();
    const { TextArea } = Input;
    const selectedTemplateType = useSelector((state: RootState) => state.agrialertTemplate.templateType);
    const initTempDetail = useSelector((state: RootState) => state.agrialertTemplate.tempDetails);
    const initSubsDetail = useSelector((state: RootState) => state.agrialertTemplate.subscriptionDetails);
    const uploadFileContent=useSelector((state: RootState) => state.agrialertTemplate.fileContent);
    const translateData = useSelector((state: RootState) => state.agrialertTemplate.translateData);
    const [templateId,setTemplateId] = useState(null);
    const [form] = Form.useForm();
    const { Option } = Select;
    const [loading, setLoading] = useState<boolean>(false);

    //=========  used for AgriAlertLocation  ============
    const [locationList,setLocationList]=useState<locationListModel[]>([]);
    const childChangeLocationListCallback = (tmpLocationList:locationListModel[])=>{
        setLocationList(tmpLocationList);
    };
    //=========  used for AgriAlertLocation  ============

    //template or subscrible label
    const [nameText,setNameText]=useState('');
    const [tempOrSubName,setTempOrSubName]=useState('');
    const changNameText=()=>{
        console.log(selectedTemplateType);
        if((selectedTemplateType === TemplateEnumType.SUBSCRIBE)||
           (selectedTemplateType === TemplateEnumType.VIEWSUBSCRITION)||
           (selectedTemplateType === TemplateEnumType.MODIFYSUBSCRIBE)){
            setNameText('Subscription Name:');
        }else{
            setNameText('Template Name:');
        }
    };
    //tempOrSubName change function
    const onChangeForTempOrSubName=(e)=>{
        console.log('temaplname:',e.target.value);
        setTempOrSubName(e.target.value);
        dispatch(updateTempOrSubName(e.target.value));
    };

    //Editor
    //#region
    const [editor, setEditor] = useState<IDomEditor | null>(null);
    const [html, setHtml] = useState('');
    const [editFlag,setEditFlag] = useState(false);

    //Tool configuration
    const toolbarConfig: Partial<IToolbarConfig> = {};
    //Editor configuration
    const editorConfig: Partial<IEditorConfig> = {
        placeholder: 'Write the mail',
        // onBlur: editor => setHtml(editor?.getHtml())
    };
    const editorOnchange=(tmpEdit)=>{
        if(editFlag){
            setEditFlag(false);
            return;
        }
        setHtml(tmpEdit?.getHtml());
    };

    // It is important to destroy editor in time!
    useEffect(() => {
        return () => {
            if (editor == null) return;
            editor.destroy();
            setEditor(null);
        };
    }, [editor]);

    //Exclude some menus
    toolbarConfig.excludeKeys = [
        'headerSelect','blockquote','numberedList','bulletedList',
        'codeBlock', 'undo', 'redo', 'color', 'bgColor', 'fontSize', 'fontFamily', 'lineHeight', 'emotion', 'group-image', 'divider', 'todo', 'group-indent',
        'insertTable',
        'group-video',
        'group-more-style',// Exclude the menu group and write the value of the menu group key
        'fullScreen','insertLink'
    ];
    //#endregion

    //Location
    //#region
    useEffect(()=>{
        if(initTempDetail?.locationList?.length >= 1){
            //console.log('666 aa form',{...form.getFieldsValue()});
            form.setFieldsValue({
                ...form.getFieldsValue(),
                items: initTempDetail?.locationList
            });
        }
    },[initTempDetail]);

    //all active switch
    //#region
    const [isActiveTemplate, setIsActiveTemplate] = useState(true);
    const [isActiveHistorical, setIsActiveHistorical] = useState(true);
    const [isActiveForecast, setIsActiveForecast] = useState(true);
    const [isActiveForecastTable, setIsActiveForecastTable] = useState(true);
    const [isActiveForecastTableHourly, setIsActiveForecastTableHourly] = useState(true);
    const [isActiveForecastChart, setIsActiveForecastChart] = useState(true);
    const [isActiveSpray, setIsActiveSpray] = useState(true);
    const [isActiveAgronomic,setIsActiveAgronomic] = useState(true);
    const [isActiveControlSubscriptionContent,setIsActiveControlSubscriptionContent] = useState(false);

    // 将 isActive 转换为 activeKey 数组
    const activeKey2 = isActiveHistorical ? ['1'] : [];
    const activeKey3 = isActiveForecast ? ['1'] : [];
    const activeKey4 = isActiveSpray ? ['1'] : [];
    const activeKey5 = isActiveForecastTable ? ['1'] : [];
    const activeKey6 = isActiveForecastChart ? ['1'] : [];
    const activeKey7 = isActiveForecastTableHourly ? ['1'] : [];
    const activeKey8 = isActiveAgronomic ? ['1'] : [];

    const customClass2 = isActiveHistorical ? '' : 'active-header';
    const customClass3 = isActiveForecast ? '' : 'active-header';
    const customClass4 = isActiveSpray ? '' : 'active-header';
    const customClass5 = isActiveForecastTable ? '' : 'active-header';
    const customClass6 = isActiveForecastChart ? '' : 'active-header';
    const customClass7 = isActiveForecastTableHourly ? '' : 'active-header';
    const customClass8 = isActiveAgronomic ? '' : 'active-header';


    const onChangeforSwitch = (checked,type) => {
        switch(type){
            case 'template':
                //console.log('666:template:',checked);
                setIsActiveTemplate(!isActiveTemplate);
                break;
            case 'historical':
                //console.log('666:historical:',checked);
                setIsActiveHistorical(!isActiveHistorical);
                break;
            case 'forecast':
                setIsActiveForecast(!isActiveForecast);
                break;
            case 'forecastTableDaily':
                setIsActiveForecastTable(!isActiveForecastTable);
                break;
            case 'forecastTableHourly':
                setIsActiveForecastTableHourly(!isActiveForecastTableHourly);
                break;
            case 'forecastChart':
                setIsActiveForecastChart(!isActiveForecastChart);
                break;
            case 'spray':
                setIsActiveSpray(!isActiveSpray);
                break;
            case 'agronomic':
                setIsActiveAgronomic(!isActiveAgronomic);
                break;
            case 'controlSubscriptionContent':
                setIsActiveControlSubscriptionContent(!isActiveControlSubscriptionContent);
                break;
            default:
                console.log(`Selected value: ${checked}`);
        }
    };
    //#endregion

    //time Zone
    //#region
    //get time zone list
    const [timeZoneList,setTimeZoneList]=useState<ITimezoneListResModel[]>();
    const getTimeZoneLists=async()=>{
        const response=await getTimezoneList();
        setTimeZoneList(response.data);
    };
    //selected time zone
    const [timeZoneIdData,setTimeZoneIdData]=useState<number>();
    const [timeZoneOffsetData,setTimeZoneOffsetData]=useState<number>();
    const onChangeForTimeZone = (value) => {
        setTimeZoneIdData(value);
        //find selected timeZoneOffset
        const selectedTimeZone = timeZoneList.find((tz) => tz.timezoneId === value);
        setTimeZoneOffsetData(selectedTimeZone.timezonOffset);
    };
    //#endregion

    const [locationCheckFlag,setLocationCheckFlag] = useState(true);
    const childChangeLocationCheckFlag = (flag:boolean)=>{
        setLocationCheckFlag(flag);
    };

    //get other Option
    //#region
    const [templateOptions,setTemplateOptions]=useState<ITemplateOptionsResModel>();
    const getTemOptions=async()=>{
        const response=await getTemplateOptions();
        setTemplateOptions(response.data);
    };
    const [selectedLanguageCode,setSelectedLanguageCode]=useState('');
    const [selectedUnit,setSelectedUnit]=useState('metric');
    const [selectedVariablesHis, setSelectedVariablesHis] = useState([]);
    const [selectedVariablesFore, setSelectedVariablesFore] = useState([]);
    const [selectedForecastTableDailyVariables, setSelectedForecastTableDailyVariables] = useState([]);
    const [selectedForecastTableHourlyVariables, setSelectedForecastTableHourlyVariables] = useState([]);
    const [selectedForecastChartVariables, setSelectedForecastChartVariables] = useState([]);
    const [selectedSpary, setSelectedSpary] = useState([]);
    const [selectedHistoricalDays,setSelectedHistoricalDays]=useState<number>();

    const [selectedForecastCharts,updateSelectedForecastCharts] = useImmer<IForecastChartOrTableModel[]>([]);
    const [selectedForecastTables,updateSelectedForecastTables] = useImmer<IForecastChartOrTableModel[]>([]);
    const [selectedHistoricalCharts,updateSelectedHistoricalCharts] = useImmer<IHistoricalChartsModel[]>([]);
    const [selectedAgronomic,setSelectedAgronomic] = useState<IAgronomicRedommedationModel[]>([]);
    const [initFlag,setInitFlag] = useState<boolean>(false);

    const childChangeSelectedAgronomic = (data:IAgronomicRedommedationModel[])=>{
        setSelectedAgronomic(data);
    };
    const childChangeInitFlag = (data:boolean) =>{
        setInitFlag(data);
    };
    const childChangeSelectedForecastCharts = (updateFn)=>{
        updateSelectedForecastCharts(draft => {
            updateFn(draft);
        });
    };
    const childChangeSelectedForecastTable = (updateFn)=>{
        updateSelectedForecastTables(draft => {
            updateFn(draft);
        });
    };
    const childChangeSelectedHistoricalCharts = (updateFn)=>{
        updateSelectedHistoricalCharts(draft => {
            updateFn(draft);
        });
    };

    const initSelectedValue = ()=>{
        // init Selected Historical Charts
        const tmpHistoricalChartsItem:IHistoricalChartsModel = {
            sortNumber: 0,
            historicalAggregation: null,
            historicalDays: null,
            historicalVariables: null,
            historicalVariablesForArray: []
        };
        updateSelectedHistoricalCharts( draft => {
            draft.push(tmpHistoricalChartsItem);
        });
        // init Selected Forecast Charts
        const tmpForecastChartsItem:IForecastChartOrTableModel = {
            sortNumber: 0,
            aggregation: null,
            variables: null,
            variablesForArray: [],
            forecastDays: null
        };
        updateSelectedForecastCharts( draft => {
            draft.push(tmpForecastChartsItem);
        });
        // init Selected Forecast Tables
        const tmpForecastTablesItem:IForecastChartOrTableModel = {
            sortNumber: 0,
            aggregation: null,
            variables: null,
            variablesForArray: [],
            forecastDays: null
        };
        updateSelectedForecastTables( draft => {
            draft.push(tmpForecastTablesItem);
        });
    };
    console.log('lanxue forecast ',selectedForecastCharts);

    //Convert array to string for saving to the database
    const arrayToStringWithSemicolon = (array: string[]): string => {
        if(array?.length>0)
            return array?.map(item => item.trim()).filter(item => item !== '').join(';')+ ';';
        else
            return '';
    };

    const onChangeForTemOptions = (value,type) => {
        switch(type){
            case 'language':
                //console.log('666:language:',value);
                setSelectedLanguageCode(value);
                break;
            case 'weatherChartVariablesHis':
                setSelectedVariablesHis(value);
                //console.log('666:weatherChartVariablesHis:',value);
                break;
            case 'weatherChartVariablesFore':
                setSelectedVariablesFore(value);
                //console.log('666:weatherChartVariablesFore:',value);
                break;
            case 'forecastTableDailyVariables':
                setSelectedForecastTableDailyVariables(value);
                break;
            case 'forecastTableHourlyVariables':
                setSelectedForecastTableHourlyVariables(value);
                break;
            case 'forecastChartVariables':
                setSelectedForecastChartVariables(value);
                break;
            case 'historicalChartDays':
                setSelectedHistoricalDays(value);
                //console.log('666:historicalChartDays:',value);
                break;
            case 'spray':
                setSelectedSpary(value);
                break;
            case 'unit':
                setSelectedUnit(value);
                break;
            default:
                console.log(`Selected value: ${value}`);
        }
    };
    //#endregion

    //report Aggregation
    //#region
    const [selectedAnOptin,setSelectedAnOptin]=useState('');
    const onChangeforSelectAnOptin=(value)=>{
        console.log('66option:',value);
        setSelectedAnOptin(value);
    };
    // console.log('6666selectedAnOptin:',selectedAnOptin);

    //when select weekly,show week div
    //Base on checkBox isChecked,save to database with array format
    const [selectedDays, setSelectedDays] = useState([]);
    const onChangeForCheckBox = (e, day) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            setSelectedDays(prevSelectedDays => [...prevSelectedDays, day]);
        } else {
            setSelectedDays(prevSelectedDays => prevSelectedDays.filter(d => d !== day));
        }
    };
    //console.log('6666selectedDays:',selectedDays);
    const [isShowWeekDiv,setIsShowWeekDiv]=useState(false);
    const [isShowTip,setIsShowTip]=useState(false);

    const showWeekDivAction=()=>{
        if(selectedAnOptin==='weekly'){
            setIsShowWeekDiv(true);
            if(selectedDays?.length===0){
                setIsShowTip(true);
            }else{
                setIsShowTip(false);
            }
        }
        else{
            setSelectedDays([]);
            setIsShowWeekDiv(false);
        }
    };

    useEffect(()=>{
        showWeekDivAction();
    },[selectedAnOptin]);
    //#endregion

    //hour option
    const [hourOptions,setHourOptions]=useState([]);
    const generateHourOptions = () => {
        const array= Array.from({ length: 24 }, (_, index) => {
            const hour = index.toString().padStart(2, '0');
            const minute = '00';
            return{
                value: index,
                label: `${hour}:${minute}`
            };
        });
        setHourOptions(array);
    };

    const [selectedTime,setSelectedTime]=useState<number>(0);
    const handleChangeForTime=(value) => {
        setSelectedTime(value);
    };

    //Aggregation
    const [selectedAggregation,setselectedAggregation]=useState<string>('');
    const onChangeForAggregation=(value) => {
        console.log('222',value);
        setselectedAggregation(value);
    };

    //subject
    const [inputSubject,setInputSubject]=useState('');
    const onChangeForSubject=(e)=>{
        console.log('666input',e.target.value);
        setInputSubject(e.target.value);
    };

    //start date and end date
    const [selectedStartDate,setSelectedStartDate]=useState<moment.Moment | null>(null);
    const [selectedEndDate,setSelectedEndDate]=useState<moment.Moment | null>(null);
    const [dateFormat, setDateFormat] = useState('MM/DD/YYYY');
    const onChangeForStartDate = (dates, dateStrings) => {
        setSelectedStartDate(dates);
        console.log('onChangeForStartDate:',dates);
    };
    const onChangeForEndDate = (dates, dateStrings) => {
        if (dates && moment(dates).isBefore(moment(), 'day')) {
            dispatch(updateWarningMessage('The end date cannot be earlier than today'));
            setSelectedEndDate(null);
        } else {
            setSelectedEndDate(dates);
        }
    };

    //when the component is rendered to the screen,call below api,for get datas
    useEffect(()=>{
        getTimeZoneLists();
        getTemOptions();
        generateHourOptions();
        getAllBanner();
        initSelectedValue();
    },[]);

    //Banner
    //#region
    //get uploaded banners from database
    const [banners,setBannners]=useState<IgetAllBannersResModel[]>();
    const getAllBanner = async () => {
        const response = await getAllBanners();
        setBannners(response.data);
        dispatch(updateAllBanner(response.data));
    };
    //selectedBanners
    const [selectedBanners, setSelectedBanners] = useState([]);
    const handleChangeForBannner = (value) => {
        setSelectedBanners(value);
        console.log('Selected banners:', value);
    };
    //#endregion

    //when click 'Delete' button,execute
    const deleteBtn=async ()=>{
        const updateCurrentTempId: deleteTemplateReqModel = { templateId: initTempDetail.templateId};
        const res=await deleteTemplate(updateCurrentTempId);
        if(res==='Success'){
            dispatch(updateSuccessMessage('Delete sucessfully.'));
            dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
        }
        else
            dispatch(updateWarningMessage(res));
    };

    //when click 'Cancel' button,execute
    const cancelBtn=()=>{
        dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
    };

    //when save successfully,need excute updateReportNextSendTime
    const updateNextSendTime=async()=>{
        console.log('lanxue test templateid',templateId);
        if(templateId === 0 || templateId === null){
            await updateReportNextSendTime(null);
        }
        else{
            await updateReportNextSendTime({
                templateIds: [templateId],
                nextSendTime: null
            });
        }

    };
    //add new s3
    const [uploadBanners, setUploadBanners] = useState([]);
    const addS3Name = (newS3Name: string) => {
        setUploadBanners(prevList => [...prevList, newS3Name]);
    };

    //upload banner to database
    const uploadBannerFunction = async()=>{
        // let uploadFlag = false;
        let tmpUploadBannerS3Name = [];
        if(uploadFileContent?.length>0){
            const res =await uploadReportBanner(uploadFileContent);
            if(res?.message==='Success'){
                tmpUploadBannerS3Name = res?.data?.map( x => x.bannerS3Name);
                dispatch(updateFileContent([]));
                //dispatch(updateSuccessMessage('Uploaded successfully'));
                //uploadSuccessCallback();
            }else{
                dispatch(updateWarningMessage('Banner upload failed.'));
                // uploadFlag = true;
            }
        }
        return tmpUploadBannerS3Name;
    };

    const getLocationListAfterModifyFromAddress = ():locationListModel[]=>{
        const tmpLocationList:locationListModel[] = JSON.parse(JSON.stringify(locationList)) as locationListModel[];
        // tmpLocationList.map((item)=>{
        //     // item.fromEmail = item?.fromEmail?.replace(/^([^@]+)@.*/, (match, p1) => `${p1}@cehub.syngenta.com`);
        //     item.fromEmail = item?.fromEmail?.replace(/^([^@]+)@.*/, (match, p1) => `${p1}`);
        //     return item;
        // });
        for(let i = 0; i < tmpLocationList?.length; i++){
            tmpLocationList[i].sortNumber = i;
            tmpLocationList[i].fromEmail = tmpLocationList[i]?.fromEmail?.replace(/^([^@]+)@.*/, (match, p1) => `${p1}`);
        }
        console.log('save location: ',tmpLocationList);
        return tmpLocationList;
    };

    //when click 'create template',save function
    const addTemplateData=async ()=>{
        try{
            setLoading(true);
            const flag = judgeMandatoryField();
            //const uploadFlag=uploadBanner();
            const tmpUploadBannerS3Name = await uploadBannerFunction();
            const tmpUploadBanner = arrayToStringWithSemicolon(tmpUploadBannerS3Name);
            const tmpSelectedBanner = arrayToStringWithSemicolon(selectedBanners);
            console.log('666banner',tmpUploadBanner);
            if(flag){
                setLoading(false);
                return;
            }else{
                console.log('666enter');
                const checkIsValidName =await checkIsValidTempOrSubName(tempOrSubName);
                if(checkIsValidName.data){
                    console.log('enter add template');
                    const tmpLocationList = getLocationListAfterModifyFromAddress();
                    const res=await addTemplate(
                        {
                            // locationList: locationList,
                            locationList: tmpLocationList,
                            templateName: tempOrSubName,
                            timezoneId: timeZoneIdData,
                            timezoneOffset: timeZoneOffsetData,
                            startDate: selectedStartDate?.format('YYYY-MM-DD'),
                            endDate: selectedEndDate===null?'2050-01-01':selectedEndDate.format('YYYY-MM-DD'),
                            templateIsActive: isActiveTemplate,
                            isControlSubscriptionContent: isActiveControlSubscriptionContent,
                            isShowHistoricalChart: isActiveHistorical,
                            isShowForecastChart: isActiveForecastChart,
                            isShowForecastTable: isActiveForecastTable,
                            isShowForecastTableHourly: isActiveForecastTableHourly,
                            isShowSpray: isActiveSpray,
                            reportHour: selectedTime,
                            reportAggregation: selectedAnOptin,
                            reportWeek: arrayToStringWithSemicolon(selectedDays),
                            reportLanguageCode: selectedLanguageCode,
                            unit: selectedUnit,
                            reportSubject: inputSubject,
                            reportMessage: html,
                            reportBanner: tmpUploadBanner + tmpSelectedBanner,
                            historicalAggregation: selectedAggregation,
                            historicalDays: selectedHistoricalDays,
                            historicalVariables: arrayToStringWithSemicolon(selectedVariablesHis),
                            forecastVariables: arrayToStringWithSemicolon(selectedVariablesFore),
                            forecastTableDailyVariables: arrayToStringWithSemicolon(selectedForecastTableDailyVariables),
                            forecastTableHourlyVariables: arrayToStringWithSemicolon(selectedForecastTableHourlyVariables),
                            forecastChartVariables: arrayToStringWithSemicolon(selectedForecastChartVariables),
                            sprayType: arrayToStringWithSemicolon(selectedSpary),
                            isShowAgronomic: isActiveAgronomic,
                            agronomicRecommendations: (selectedAgronomic?.length === 1 && selectedAgronomic?.[0]?.agronomicType === null)?
                                null : selectedAgronomic,
                            historicalCharts: selectedHistoricalCharts,
                            forecastCharts: selectedForecastCharts,
                            forecastTables: selectedForecastTables
                        });
                    if (res=='Success'){
                        // uploadBannerFunction();
                        console.log('save success');
                        dispatch(updateSuccessOpen(true));
                        setLoading(false);
                        dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
                        updateNextSendTime();
                    }
                    else{
                        dispatch(updateWarningMessage('Template creation failed.'));
                        setLoading(false);
                    }}
                else{
                    dispatch(updateWarningMessage('The new template or subscription name already exists,please rename it.'));
                    setLoading(false);
                }}
        }
        catch (e) {
            return false;
        }
    };
    //when click 'edit' button,save function
    const saveTemplateData=async ()=>{
        setLoading(true);
        const flag = judgeMandatoryField();
        const tmpUploadBannerS3Name = await uploadBannerFunction();
        const tmpUploadBanner = arrayToStringWithSemicolon(tmpUploadBannerS3Name);
        const tmpSelectedBanner = arrayToStringWithSemicolon(selectedBanners);
        if(flag){
            setLoading(false);
            return;
        }else{
            const tmpLocationList = getLocationListAfterModifyFromAddress();
            if(tempOrSubName!==initTempDetail?.templateName){
                const checkIsValidName =await checkIsValidTempOrSubName(tempOrSubName);
                if(checkIsValidName.data){
                    const res=await saveTemplate(
                        {
                            templateId: initTempDetail?.templateId,
                            templateName: tempOrSubName,
                            // locationList:  locationList,
                            locationList:  tmpLocationList,
                            templateIsActive: isActiveTemplate,
                            isControlSubscriptionContent: isActiveControlSubscriptionContent,
                            timezoneId: timeZoneIdData,
                            timezoneOffset: timeZoneOffsetData,
                            startDate: selectedStartDate?.format('YYYY-MM-DD'),
                            endDate: selectedEndDate===null?'2050-01-01':selectedEndDate.format('YYYY-MM-DD'),
                            isShowHistoricalChart: isActiveHistorical,
                            isShowForecastChart: isActiveForecastChart,
                            isShowForecastTable: isActiveForecastTable,
                            isShowForecastTableHourly: isActiveForecastTableHourly,
                            isShowSpray: isActiveSpray,
                            reportHour: selectedTime,
                            reportAggregation: selectedAnOptin,
                            reportWeek: arrayToStringWithSemicolon(selectedDays),
                            reportLanguageCode: selectedLanguageCode,
                            unit: selectedUnit,
                            reportSubject: inputSubject,
                            reportMessage: html,
                            reportBanner: tmpUploadBanner+tmpSelectedBanner,
                            historicalAggregation: selectedAggregation,
                            historicalDays: selectedHistoricalDays,
                            historicalVariables: arrayToStringWithSemicolon(selectedVariablesHis),
                            forecastVariables: arrayToStringWithSemicolon(selectedVariablesFore),
                            forecastTableDailyVariables: arrayToStringWithSemicolon(selectedForecastTableDailyVariables),
                            forecastTableHourlyVariables: arrayToStringWithSemicolon(selectedForecastTableHourlyVariables),
                            forecastChartVariables: arrayToStringWithSemicolon(selectedForecastChartVariables),
                            sprayType: arrayToStringWithSemicolon(selectedSpary),
                            editableFooter:footerValue,
                            isShowAgronomic: isActiveAgronomic,
                            agronomicRecommendations: (selectedAgronomic?.length === 1 && selectedAgronomic?.[0]?.agronomicType === null)?
                                null : selectedAgronomic,
                            historicalCharts: selectedHistoricalCharts,
                            forecastCharts: selectedForecastCharts,
                            forecastTables: selectedForecastTables
                        });
                    if (res=='Success'){
                        uploadBannerFunction();
                        console.log('6666uploadBanners:',uploadBanners);
                        dispatch(updateSuccessOpen(true));
                        setLoading(false);
                        dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
                        updateNextSendTime();
                    }
                    else{
                        dispatch(updateWarningMessage('Template saving failed.'));
                        setLoading(false);
                    }
                }
                else{
                    dispatch(updateWarningMessage('The new template or subscription name already exists,please rename it.'));
                    setLoading(false);
                }
            }else{
                const res=await saveTemplate(
                    {
                        templateId: initTempDetail?.templateId,
                        templateName: initTempDetail?.templateName,
                        // locationList:  locationList,
                        locationList:  tmpLocationList,
                        templateIsActive:isActiveTemplate,
                        isControlSubscriptionContent: isActiveControlSubscriptionContent,
                        timezoneId: timeZoneIdData,
                        timezoneOffset: timeZoneOffsetData,
                        startDate: selectedStartDate?.format('YYYY-MM-DD'),
                        endDate: selectedEndDate===null?'2050-01-01':selectedEndDate.format('YYYY-MM-DD'),
                        isShowHistoricalChart: isActiveHistorical,
                        isShowForecastChart: isActiveForecastChart,
                        isShowForecastTable: isActiveForecastTable,
                        isShowForecastTableHourly: isActiveForecastTableHourly,
                        isShowSpray: isActiveSpray,
                        reportHour: selectedTime,
                        reportAggregation: selectedAnOptin,
                        reportWeek: arrayToStringWithSemicolon(selectedDays),
                        reportLanguageCode: selectedLanguageCode,
                        unit: selectedUnit,
                        reportSubject: inputSubject,
                        reportMessage: html,
                        reportBanner: tmpUploadBanner+tmpSelectedBanner,
                        historicalAggregation: selectedAggregation,
                        historicalDays: selectedHistoricalDays,
                        historicalVariables: arrayToStringWithSemicolon(selectedVariablesHis),
                        forecastVariables: arrayToStringWithSemicolon(selectedVariablesFore),
                        forecastTableDailyVariables: arrayToStringWithSemicolon(selectedForecastTableDailyVariables),
                        forecastTableHourlyVariables: arrayToStringWithSemicolon(selectedForecastTableHourlyVariables),
                        forecastChartVariables: arrayToStringWithSemicolon(selectedForecastChartVariables),
                        sprayType: arrayToStringWithSemicolon(selectedSpary),
                        editableFooter:footerValue,
                        isShowAgronomic: isActiveAgronomic,
                        agronomicRecommendations: (selectedAgronomic?.length === 1 && selectedAgronomic?.[0]?.agronomicType === null)?
                            null : selectedAgronomic,
                        historicalCharts: selectedHistoricalCharts,
                        forecastCharts: selectedForecastCharts,
                        forecastTables: selectedForecastTables
                    });
                if (res=='Success'){
                    uploadBannerFunction();
                    dispatch(updateSuccessOpen(true));
                    setLoading(false);
                    dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
                    updateNextSendTime();
                }
                else{
                    dispatch(updateWarningMessage('Template saving failed.'));
                    setLoading(false);
                }
            }
        }
    };

    //when add 'subcription' button ,save function
    const addSubScriptionData=async()=>{
        setLoading(true);
        const flag = judgeMandatoryField();
        const tmpUploadBannerS3Name = await uploadBannerFunction();
        const tmpUploadBanner = arrayToStringWithSemicolon(tmpUploadBannerS3Name);
        const tmpSelectedBanner = arrayToStringWithSemicolon(selectedBanners);
        if(flag){
            setLoading(false);
            return;
        }else{
            const checkIsValidName =await checkIsValidTempOrSubName(tempOrSubName);
            const tmpLocationList = getLocationListAfterModifyFromAddress();
            if(checkIsValidName.data){
                const res=await addSubscription(
                    {
                        subscribeFromTemplateId:initTempDetail?.templateId,
                        locationList: tmpLocationList,
                        subscriptionName: tempOrSubName,
                        timezoneId: timeZoneIdData,
                        timezoneOffset: timeZoneOffsetData,
                        startDate: selectedStartDate?.format('YYYY-MM-DD'),
                        endDate: selectedEndDate===null?'2050-01-01':selectedEndDate.format('YYYY-MM-DD'),
                        reportHour: selectedTime,
                        reportAggregation: selectedAnOptin,
                        reportWeek: arrayToStringWithSemicolon(selectedDays),
                        reportLanguageCode: selectedLanguageCode,
                        reportSubject: inputSubject,
                        reportMessage: html,
                        reportBanner:  tmpUploadBanner+tmpSelectedBanner,
                        editableFooter:footerValue,
                        unit: selectedUnit,
                    });
                if (res=='Success'){
                    dispatch(updateSuccessMessage('Subscription added successfully.'));
                    setLoading(false);
                    dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
                    updateNextSendTime();
                }
                else{
                    dispatch(updateWarningMessage('Subscription addition failed.'));
                    setLoading(false);
                }}
            else{
                dispatch(updateWarningMessage('The new template or subscription name already exists,please rename it.'));
                setLoading(false);
            }
        }
    };

    //when click 'modify subcription' button,save function
    const modifiedSubcription=async()=>{
        setLoading(true);
        const flag = judgeMandatoryField();
        const tmpUploadBannerS3Name = await uploadBannerFunction();
        const tmpUploadBanner = arrayToStringWithSemicolon(tmpUploadBannerS3Name);
        const tmpSelectedBanner = arrayToStringWithSemicolon(selectedBanners);
        if(flag){
            setLoading(false);
            return;
        }else{
            const tmpLocationList = getLocationListAfterModifyFromAddress();
            if((tempOrSubName!=='')&&(tempOrSubName!==initSubsDetail?.subscriptionName)){
                const checkIsValidName =await checkIsValidTempOrSubName(tempOrSubName);
                if(checkIsValidName.data){
                    const res=await saveSubscription(
                        {
                            subscriptionId: initSubsDetail?.subscriptionId,
                            locationList:  tmpLocationList,
                            subscriptionName: tempOrSubName,
                            timezoneId: timeZoneIdData,
                            timezoneOffset: timeZoneOffsetData,
                            startDate: selectedStartDate?.format('YYYY-MM-DD'),
                            endDate: selectedEndDate===null?'2050-01-01':selectedEndDate.format('YYYY-MM-DD'),
                            reportHour: selectedTime,
                            reportAggregation: selectedAnOptin,
                            reportWeek: arrayToStringWithSemicolon(selectedDays),
                            reportLanguageCode: selectedLanguageCode,
                            reportSubject: inputSubject,
                            reportMessage: html,
                            reportBanner:  tmpUploadBanner+tmpSelectedBanner,
                            editableFooter:footerValue,
                            unit: selectedUnit,
                        });
                    if (res=='Success'){
                        dispatch(updateSuccessMessage('Data saved successfully.'));
                        setLoading(false);
                        dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
                        updateNextSendTime();
                    }
                    else{
                        dispatch(updateWarningMessage('Data saving failed.'));
                        setLoading(false);
                    }
                }
                else{
                    dispatch(updateWarningMessage('The new template or subscription name already exists,please rename it.'));
                    setLoading(false);
                }
            }else{
                const res=await saveSubscription(
                    {
                        subscriptionId: initSubsDetail?.subscriptionId,
                        locationList:  tmpLocationList,
                        subscriptionName: initSubsDetail?.subscriptionName,
                        timezoneId: timeZoneIdData,
                        timezoneOffset: timeZoneOffsetData,
                        startDate: selectedStartDate?.format('YYYY-MM-DD'),
                        endDate: selectedEndDate===null?'2050-01-01':selectedEndDate.format('YYYY-MM-DD'),
                        reportHour: selectedTime,
                        reportAggregation: selectedAnOptin,
                        reportWeek: arrayToStringWithSemicolon(selectedDays),
                        reportLanguageCode: selectedLanguageCode,
                        reportSubject: inputSubject,
                        reportMessage: html,
                        reportBanner:  tmpUploadBanner+tmpSelectedBanner,
                        editableFooter:footerValue,
                        unit: selectedUnit,
                    });
                if (res=='Success'){
                    dispatch(updateSuccessMessage('Data saved successfully.'));
                    setLoading(false);
                    dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
                    updateNextSendTime();
                }
                else{
                    dispatch(updateWarningMessage('Data saving failed.'));
                    setLoading(false);
                }
            }
        }
    };

    //Preview button
    //#region
    const [isShowPreview, setIsShowPreview] = useState(false);
    const [templateDate,setTemplateDate]=useState('');
    const [todayLocalDate,setTodayLocalDate]=useState('');
    const formattedDate = moment().format('YYYY/MM/DD HH:mm:ss');
    useEffect(()=>{
        if((selectedTemplateType === TemplateEnumType.VIEWSUBSCRITION)||
           (selectedTemplateType === TemplateEnumType.MODIFYSUBSCRIBE)){
            setTemplateDate(initSubsDetail?.templateCreateTime);
            setTodayLocalDate(initSubsDetail?.todayLocalTime);
        }
        if((selectedTemplateType === TemplateEnumType.VIEWTEMPLATE)||
           (selectedTemplateType === TemplateEnumType.EDITTEMPLATE)){
            setTemplateDate(initTempDetail?.templateCreateTime);
            setTodayLocalDate(initTempDetail?.todayLocalTime);
        }
        if((selectedTemplateType === TemplateEnumType.SUBSCRIBE)||
           (selectedTemplateType === TemplateEnumType.CREATETEMPLATE)){
            setTemplateDate(formattedDate);
            setTodayLocalDate(formattedDate);
        }
    },[selectedTemplateType]);


    const childChangeShowPreview = ()=>{
        setIsShowPreview(false);
    };
    //#endregion

    //when view template/subcription,all fields disabled
    //#region
    const [isDisabled, setIsDisabled] = useState(false);
    const toggleDisabled = () => {
        if((selectedTemplateType === TemplateEnumType.VIEWTEMPLATE)||
           (selectedTemplateType === TemplateEnumType.VIEWSUBSCRITION))
            setIsDisabled(true);
        else{
            setIsDisabled(false);
        }
    };
    //#endregion

    //if selectedTemplateType changed,execute
    useEffect(()=>{
        toggleDisabled();
        changNameText();
    },[selectedTemplateType]);

    //Aggregation options hard code
    //#region
    const optionsSelect = [
        {
            id: 1,
            label: 'Daily',
            value: 'daily',
        },
        {
            id: 2,
            label: 'Weekly',
            value: 'weekly',
        },
        {
            id: 3,
            label: 'Monthly',
            value: 'monthly',
        },
    ];
    const options = optionsSelect.map(item => (
        <Option key={item.id} value={item.value}>
            {item.label}
        </Option>
    ));
    //exclude Monthly
    const filteredOptions = optionsSelect.filter(item => item.id !== 3);
    const options2 = filteredOptions.map(item => (
        <Option key={item.id} value={item.value}>
            {item.label}
        </Option>
    ));
    //#endregion

    //If it is template,page show chart part
    const [isTempPage,setIsTempPage]=useState<boolean>(true);
    useEffect(()=>{
        if((selectedTemplateType === (TemplateEnumType.SUBSCRIBE))||
        (selectedTemplateType === (TemplateEnumType.VIEWSUBSCRITION))||
        (selectedTemplateType === (TemplateEnumType.MODIFYSUBSCRIBE)))
            setIsTempPage(false);
        else
            setIsTempPage(true);
    },[]);

    const initHistoricalChartsFromApiData = (data?: IHistoricalChartsModel[])=>{
        if(data?.length >= 1) {
            const tmpHistorical:IHistoricalChartsModel[] = [];
            data?.forEach((item,index)=>{
                const tmpItem:IHistoricalChartsModel = {
                    sortNumber: index,
                    historicalAggregation: item?.historicalAggregation,
                    historicalDays: item?.historicalDays,
                    historicalVariables: item?.historicalVariables,
                    historicalVariablesForArray: item?.historicalVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null)
                };
                tmpHistorical.push(tmpItem);
            });
            updateSelectedHistoricalCharts(draft =>{
                draft.length = 0;
                draft.push(...tmpHistorical);
            });
        }
    };
    const initForecastChartOrTableFromApiData = (data?: IForecastChartOrTableModel[],type?:string)=>{
        if(data?.length >= 1) {
            const tmpForecast:IForecastChartOrTableModel[] = [];
            data?.forEach((item,index)=>{
                const tmpItem:IForecastChartOrTableModel = {
                    sortNumber: index,
                    aggregation: item?.aggregation,
                    variables: item?.variables,
                    variablesForArray: item?.variables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    forecastDays: item?.forecastDays
                };
                tmpForecast.push(tmpItem);
            });
            if(type === 'charts'){
                updateSelectedForecastCharts(draft =>{
                    draft.length = 0;
                    draft.push(...tmpForecast);
                });
            }
            else if(type === 'tables'){
                updateSelectedForecastTables(draft =>{
                    draft.length = 0;
                    draft.push(...tmpForecast);
                });
            }
        }

    };

    console.log('lanxue aaa selectedAgronomic',selectedAgronomic);
    console.log('lanxue aaa initTempDetail',initTempDetail);

    //Set initial values for all fields
    useEffect(()=>{
        if(selectedTemplateType === TemplateEnumType.SUBSCRIBE){
            setTempOrSubName('');
            dispatch(updateTempOrSubName(''));
            setLocationList([{
                locationName: undefined,
                lat: null,
                lng: null,
                toUserEmail: '',
                sortNumber: 0,
                fromEmail: 'CEHub.dataplatform'
            }]);
            setTimeZoneIdData(71);
            setTimeZoneOffsetData(1);
            setSelectedAnOptin('weekly');
            setSelectedDays([]);
            setSelectedStartDate(null);
            setSelectedEndDate(null);
            setSelectedLanguageCode('en');
            setSelectedUnit('metric');
            setSelectedTime(0);
            setselectedAggregation(initTempDetail?.historicalAggregation);
            setSelectedVariablesHis(initTempDetail?.historicalVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedHistoricalDays(initTempDetail?.historicalDays);
            setSelectedVariablesFore(initTempDetail?.forecastVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedForecastTableDailyVariables(initTempDetail?.forecastTableDailyVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedForecastTableHourlyVariables(initTempDetail?.forecastTableHourlyVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedForecastChartVariables(initTempDetail?.forecastChartVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedSpary(initTempDetail?.sprayType
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedAgronomic(initTempDetail?.agronomicRecommendations);
            // set for historical charts
            initHistoricalChartsFromApiData(initTempDetail?.historicalCharts);
            // set for forecast charts
            initForecastChartOrTableFromApiData(initTempDetail?.forecastCharts,'charts');
            // set for forecast Tables
            initForecastChartOrTableFromApiData(initTempDetail?.forecastTables,'tables');
            setInitFlag(true);
            setIsActiveTemplate(initTempDetail?.templateIsActive);
            setIsActiveHistorical(initTempDetail?.isShowHistoricalChart);
            setIsActiveForecast(initTempDetail?.isShowForecastChart);
            setIsActiveForecastTable(initTempDetail?.isShowForecastTable);
            setIsActiveForecastTableHourly(initTempDetail?.isShowForecastTableHourly);
            setIsActiveForecastChart(initTempDetail?.isShowForecastChart);
            setIsActiveSpray(initTempDetail?.isShowSpray);
            setIsActiveAgronomic(initTempDetail?.isShowAgronomic);
            setTemplateDate(initTempDetail?.templateCreateTime);
            setTodayLocalDate(initTempDetail?.todayLocalTime);
            setInputSubject(initTempDetail?.reportSubject);
            setEditFlag(true);
            setTimeout(()=>setHtml(initTempDetail?.reportMessage),100);
            setSelectedBanners(initTempDetail?.reportBanner
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setFooterValue('');
        }
        else if(selectedTemplateType === TemplateEnumType.CREATETEMPLATE){
            setTempOrSubName('');
            dispatch(updateTempOrSubName(''));
            setLocationList([{
                locationName: undefined,
                lat: null,
                lng: null,
                toUserEmail: '',
                sortNumber: 0,
                fromEmail: 'CEHub.dataplatform'
            }]);
            setTimeZoneIdData(71);
            setTimeZoneOffsetData(1);
            setSelectedAnOptin('weekly');
            setSelectedDays([]);
            setSelectedStartDate(null);
            setSelectedEndDate(null);
            setSelectedLanguageCode('en');
            setSelectedUnit('metric');
            setSelectedTime(0);
            setInputSubject('');
            setEditFlag(true);
            setTimeout(()=>setHtml(''),100);
            setSelectedBanners([]);
            setselectedAggregation(undefined);
            setSelectedVariablesHis([]);
            setSelectedHistoricalDays(null);
            setSelectedVariablesFore([]);
            setSelectedForecastTableDailyVariables([]);
            setSelectedForecastTableHourlyVariables([]);
            setSelectedForecastChartVariables([]);
            setSelectedSpary([]);
            setSelectedAgronomic([]);
            setInitFlag(true);
            setIsActiveTemplate(true);
            setIsActiveControlSubscriptionContent(false);
            setIsActiveHistorical(true);
            setIsActiveForecast(true);
            setIsActiveForecastTable(true);
            setIsActiveForecastTableHourly(true);
            setIsActiveForecastChart(true);
            setIsActiveSpray(true);
            setIsActiveAgronomic(true);
            setTemplateDate(formattedDate);
            setTodayLocalDate(formattedDate);
            setFooterValue('');
        }
        else if(
            (selectedTemplateType === TemplateEnumType.EDITTEMPLATE)||
            (selectedTemplateType === TemplateEnumType.VIEWTEMPLATE)
        ){
            console.log('6666initTempDetail:',initTempDetail);
            setTempOrSubName(initTempDetail?.templateName);
            //when set sempOrSubName,need update redux
            dispatch(updateTempOrSubName(initTempDetail?.templateName));
            const tmpLocationList = initTempDetail?.locationList?.map((x)=>{
                const tmpFromEmail = x?.fromEmail || 'CEHub.dataplatform';
                return({
                    ...x,
                    fromEmail: tmpFromEmail
                });
            });
            setLocationList(tmpLocationList);
            setTemplateId(initTempDetail?.templateId);
            setTimeZoneIdData(initTempDetail?.timezoneId);
            setTimeZoneOffsetData(initTempDetail?.timezoneOffset);
            setSelectedLanguageCode(initTempDetail?.reportLanguageCode);
            setSelectedUnit(initTempDetail?.unit);
            setSelectedAnOptin(initTempDetail?.reportAggregation);
            setSelectedDays(initTempDetail?.reportWeek
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedStartDate(moment(initTempDetail?.startDate, 'YYYY-MM-DD'));
            setSelectedEndDate(moment(initTempDetail?.endDate, 'YYYY-MM-DD'));
            setSelectedTime(initTempDetail?.reportHour);
            setInputSubject(initTempDetail?.reportSubject);
            setEditFlag(true);
            setTimeout(()=>setHtml(initTempDetail?.reportMessage),100);
            setSelectedBanners(initTempDetail?.reportBanner
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setselectedAggregation(initTempDetail?.historicalAggregation);
            setSelectedVariablesHis(initTempDetail?.historicalVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedHistoricalDays(initTempDetail?.historicalDays);
            setSelectedVariablesFore(initTempDetail?.forecastVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedForecastTableDailyVariables(initTempDetail?.forecastTableDailyVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedForecastTableHourlyVariables(initTempDetail?.forecastTableHourlyVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedForecastChartVariables(initTempDetail?.forecastChartVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedSpary(initTempDetail?.sprayType
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedAgronomic(initTempDetail?.agronomicRecommendations);
            initHistoricalChartsFromApiData(initTempDetail?.historicalCharts);
            // set for forecast charts
            initForecastChartOrTableFromApiData(initTempDetail?.forecastCharts,'charts');
            // set for forecast Tables
            initForecastChartOrTableFromApiData(initTempDetail?.forecastTables,'tables');
            setInitFlag(true);
            setIsActiveTemplate(initTempDetail?.templateIsActive);
            setIsActiveControlSubscriptionContent(initTempDetail?.isControlSubscriptionContent);
            setIsActiveHistorical(initTempDetail?.isShowHistoricalChart);
            setIsActiveForecast(initTempDetail?.isShowForecastChart);
            setIsActiveForecastTable(initTempDetail?.isShowForecastTable);
            setIsActiveForecastTableHourly(initTempDetail?.isShowForecastTableHourly);
            setIsActiveForecastChart(initTempDetail?.isShowForecastChart);
            setIsActiveSpray(initTempDetail?.isShowSpray);
            setIsActiveAgronomic(initTempDetail?.isShowAgronomic);
            setTemplateDate(initTempDetail?.templateCreateTime);
            setTodayLocalDate(initTempDetail?.todayLocalTime);
            setFooterValue(initTempDetail?.editableFooter);
        }
        else if(
            (selectedTemplateType === TemplateEnumType.MODIFYSUBSCRIBE)||
            (selectedTemplateType === TemplateEnumType.VIEWSUBSCRITION)
        ){

            console.log('6666initSubsDetail:',initSubsDetail);
            setTempOrSubName(initSubsDetail?.subscriptionName);
            dispatch(updateTempOrSubName(initSubsDetail?.subscriptionName));
            const tmpLocationList = initSubsDetail?.locationList?.map((x)=>{
                const tmpFromEmail = x?.fromEmail || 'CEHub.dataplatform';
                return({
                    ...x,
                    fromEmail: tmpFromEmail
                });
            });
            setLocationList(tmpLocationList);
            setTemplateId(initSubsDetail?.subscriptionId);
            setTimeZoneOffsetData(initSubsDetail?.timezoneOffset);
            setTimeZoneIdData(initSubsDetail?.timezoneId);
            setSelectedLanguageCode(initSubsDetail?.reportLanguageCode);
            setSelectedUnit(initSubsDetail?.unit);
            setSelectedAnOptin(initSubsDetail?.reportAggregation);
            setSelectedDays(initSubsDetail?.reportWeek
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedStartDate(moment(initSubsDetail?.startDate, 'YYYY-MM-DD'));
            setSelectedEndDate(moment(initSubsDetail?.endDate, 'YYYY-MM-DD'));
            setSelectedTime(initSubsDetail?.reportHour);
            setselectedAggregation(initSubsDetail?.historicalAggregation);
            setSelectedVariablesHis(initSubsDetail?.historicalVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedHistoricalDays(initSubsDetail?.historicalDays);
            setSelectedVariablesFore(initSubsDetail?.forecastVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedForecastTableDailyVariables(initSubsDetail?.forecastTableDailyVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedForecastTableHourlyVariables(initSubsDetail?.forecastTableHourlyVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedForecastChartVariables(initSubsDetail?.forecastChartVariables
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedSpary(initSubsDetail?.sprayType
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setSelectedAgronomic(initSubsDetail?.agronomicRecommendations);
            initHistoricalChartsFromApiData(initSubsDetail?.historicalCharts);
            // set for forecast charts
            initForecastChartOrTableFromApiData(initSubsDetail?.forecastCharts,'charts');
            // set for forecast Tables
            initForecastChartOrTableFromApiData(initSubsDetail?.forecastTables,'tables');
            setInitFlag(true);
            setIsActiveTemplate(initSubsDetail?.subscriptionIsActive);
            setIsActiveHistorical(initSubsDetail?.isShowHistoricalChart);
            setIsActiveForecast(initSubsDetail?.isShowForecastChart);
            setIsActiveForecastTable(initSubsDetail?.isShowForecastTable);
            setIsActiveForecastTableHourly(initSubsDetail?.isShowForecastTableHourly);
            setIsActiveForecastChart(initSubsDetail?.isShowForecastChart);
            setIsActiveSpray(initSubsDetail?.isShowSpray);
            setIsActiveAgronomic(initSubsDetail?.isShowAgronomic);
            setTemplateDate(initSubsDetail?.templateCreateTime);
            setTodayLocalDate(initSubsDetail?.todayLocalTime);
            setInputSubject(initSubsDetail?.reportSubject);
            setEditFlag(true);
            setTimeout(()=>setHtml(initSubsDetail?.reportMessage),100);
            setSelectedBanners(initSubsDetail?.reportBanner
                ?.split(';')?.filter(x => x != '' && x != undefined && x != null));
            setFooterValue(initSubsDetail?.editableFooter);
        }
    },[selectedTemplateType]);

    //judge all mandatory fields
    const judgeMandatoryField=()=>{
        let flag = false;
        if(tempOrSubName===''||locationList[0]?.locationName==='undefined'||locationList[0]?.locationName===null||
           locationList[0]?.toUserEmail===''||timeZoneIdData===null||selectedLanguageCode===''||selectedAnOptin===''||
           selectedStartDate===null||selectedTime===null || selectedUnit === ''
        ){
            dispatch(updateWarningMessage('Please enter mandatory fields.'));
            flag = true;
        }
        if(selectedEndDate&&(selectedEndDate<selectedStartDate)){
            dispatch(updateWarningMessage('The end date should be later than the start date'));
            flag = true;
        }
        if(selectedAnOptin==='weekly'&&selectedDays?.length===0){
            dispatch(updateWarningMessage('Please enter mandatory fields.'));
            flag = true;
        }
        // check location
        if(locationList?.length >= 1){
            locationList?.forEach((item)=>{
                if (!item?.toUserEmail?.trim() ||
                    !item?.locationName?.trim() ||
                    !item?.fromEmail?.trim()) {
                    dispatch(updateWarningMessage('Please enter mandatory Location fields.'));
                    flag = true;
                }
            });
        }
        if(!locationCheckFlag){
            dispatch(updateWarningMessage('Please confirm that all provided values are valid.'));
            flag = true;
        }

        if(selectedTemplateType=== TemplateEnumType.EDITTEMPLATE ||
           selectedTemplateType=== TemplateEnumType.CREATETEMPLATE
        ){
            if(inputSubject===''){
                dispatch(updateWarningMessage('Please enter mandatory fields.'));
                flag = true;
            }
            if(isActiveHistorical){
                if(selectedHistoricalCharts?.length >= 1){
                    selectedHistoricalCharts?.forEach((item)=>{
                        if (!item?.historicalAggregation?.trim() ||
                            !item?.historicalVariables?.trim() ||
                            !item?.historicalDays
                        ) {
                            dispatch(updateWarningMessage('Please enter mandatory fields.'));
                            flag = true;
                        }
                    });
                }
                // if(selectedAggregation===''||selectedVariablesHis?.length===0||selectedHistoricalDays===null){
                //     dispatch(updateWarningMessage('Please enter mandatory fields.'));
                //     flag = true;
                // }
            }
            //if(isActiveForecastTableHourly){
            //    if(selectedForecastTableHourlyVariables?.length===0){
            //        dispatch(updateWarningMessage('Please enter mandatory fields.'));
            //        flag = true;
            //    }
            //}
            if(isActiveForecastTable){
                if(selectedForecastTables?.length >= 1){
                    selectedForecastTables?.forEach((item)=>{
                        if (!item?.aggregation?.trim() ||
                            !item?.variables?.trim()
                        ) {
                            dispatch(updateWarningMessage('Please enter mandatory fields.'));
                            flag = true;
                        }
                    });
                }
                // if(selectedForecastTableDailyVariables?.length===0){
                //     dispatch(updateWarningMessage('Please enter mandatory fields.'));
                //     flag = true;
                // }
            }
            if(isActiveForecastChart){
                if(selectedForecastCharts?.length >= 1){
                    selectedForecastCharts?.forEach((item)=>{
                        if (!item?.aggregation?.trim() ||
                            !item?.variables?.trim()
                        ) {
                            dispatch(updateWarningMessage('Please enter mandatory fields.'));
                            flag = true;
                        }
                    });
                }
                // if(selectedForecastChartVariables?.length===0){
                //     dispatch(updateWarningMessage('Please enter mandatory fields.'));
                //     flag = true;
                // }
            }
            // if(isActiveSpray){
            //     if(selectedSpary?.length===0){
            //         dispatch(updateWarningMessage('Please enter mandatory fields.'));
            //         flag = true;
            //     }
            // }
            // for agronomic
            if(isActiveAgronomic && selectedAgronomic?.length >= 1){
                selectedAgronomic?.forEach((item)=>{
                // disease
                    if(item?.agronomicType === AgronomicTypeEnum.DISEASE){
                    // not input stress value
                        if(!item?.disease?.crop || !item?.disease?.modelID){
                            dispatch(updateWarningMessage('Please select crop value'));
                            flag = true;
                        }
                        if(item?.isHistorical){
                        //  isHistirical and not input timePeriod value
                            if(!item?.historicalSetting?.timePeriod){
                                dispatch(updateWarningMessage('Please select Timeline'));
                                flag = true;
                            }
                            if(item?.historicalSetting?.timePeriod === TimePeriodEnum?.CUSTOM){
                            // timePeriod is custom, but not inpt startDate or endDate
                                if(!item?.historicalSetting?.endDate || !item?.historicalSetting?.startDate){
                                    dispatch(updateWarningMessage('Please select start or end date'));
                                    flag = true;
                                }
                            }
                        }
                    }
                    // planting
                    if(item?.agronomicType === AgronomicTypeEnum.PLANTING){
                    // not input stress value
                        if(!item?.planting){
                            dispatch(updateWarningMessage('Please select crop value'));
                            flag = true;
                        }
                        if(item?.isHistorical){
                        //  isHistirical and not input timePeriod value
                            if(!item?.historicalSetting?.timePeriod){
                                dispatch(updateWarningMessage('Please selecte Timeline'));
                                flag = true;
                            }
                            if(item?.historicalSetting?.timePeriod === TimePeriodEnum?.CUSTOM){
                            // timePeriod is custom, but not inpt startDate or endDate
                                if(!item?.historicalSetting?.endDate || !item?.historicalSetting?.startDate){
                                    dispatch(updateWarningMessage('Please select start or end date'));
                                    flag = true;
                                }
                            }
                        }
                    }
                    // spray
                    if(item?.agronomicType === AgronomicTypeEnum.SPRAY){
                    // not input stress value
                        if(!item?.spray){
                            dispatch(updateWarningMessage('Please select stress crop value'));
                            flag = true;
                        }
                        if(item?.isHistorical){
                        //  isHistirical and not input timePeriod value
                            if(!item?.historicalSetting?.timePeriod){
                                dispatch(updateWarningMessage('Please selecte Timeline'));
                                flag = true;
                            }
                            if(item?.historicalSetting?.timePeriod === TimePeriodEnum?.CUSTOM){
                            // timePeriod is custom, but not inpt startDate or endDate
                                if(!item?.historicalSetting?.endDate || !item?.historicalSetting?.startDate){
                                    dispatch(updateWarningMessage('Please select start or end date'));
                                    flag = true;
                                }
                            }
                        }
                    }
                    // stress alert
                    if(item?.agronomicType === AgronomicTypeEnum.STRESS){
                    // not input stress value
                        if(!item?.stress){
                            dispatch(updateWarningMessage('Please select crop value'));
                            flag = true;
                        }
                        if(item?.isHistorical){
                        //  isHistirical and not input timePeriod value
                            if(!item?.historicalSetting?.timePeriod){
                                dispatch(updateWarningMessage('Please selecte Timeline'));
                                flag = true;
                            }
                            if(item?.historicalSetting?.timePeriod === TimePeriodEnum?.CUSTOM){
                            // timePeriod is custom, but not inpt startDate or endDate
                                if(!item?.historicalSetting?.endDate || !item?.historicalSetting?.startDate){
                                    dispatch(updateWarningMessage('Please select start or end date'));
                                    flag = true;
                                }
                            }
                        }
                    }
                });
            }
        }



        return flag;
    };

    //show preview
    const showPreview = () => {
        const flag = judgeMandatoryField();
        if(flag){
            setLoading(false);
            dispatch(updateWarningMessage('Please enter all required fields before previewing'));
            return;
        }else{
            setIsShowPreview(true);
            dispatch(updatePreviewDetails(
                {
                    templateName: tempOrSubName,
                    // templateDate: templateDate,
                    templateDate: todayLocalDate,
                    templateBannerList: selectedBanners,
                    templateDescription: html,
                    templateLocationName: locationList[0]?.locationName,
                    templateLat: locationList[0]?.lat,
                    templateLng: locationList[0]?.lng,
                    // for historical and forecast
                    isShowHistoricalChart: isActiveHistorical,
                    isShowForecastChart: isActiveForecastChart,
                    isShowForecastTable: isActiveForecastTable,
                    isShowForecastTableHourly: isActiveForecastTableHourly,
                    historicalAggregation: selectedAggregation,
                    historicalDays: selectedHistoricalDays,
                    historicalVariables: selectedVariablesHis,
                    forecastVariables: selectedVariablesFore,
                    forecastTableDailyVariables: selectedForecastTableDailyVariables,
                    forecastTableHourlyVariables: selectedForecastTableHourlyVariables,
                    forecastChartVariables: selectedForecastChartVariables,
                    // for spray
                    isShowSpray: isActiveSpray,
                    sprayType: selectedSpary,
                    languageCode: selectedLanguageCode,
                    reportUnit: selectedUnit,
                    // for agronomic
                    isShowAgronomic: isActiveAgronomic,
                    agronomic: selectedAgronomic,
                    historicalCharts: selectedHistoricalCharts,
                    forecastCharts: selectedForecastCharts,
                    forecastTables: selectedForecastTables
                }
            ));
        }
    };
    //Editable Footer
    const [footerValue,setFooterValue]=useState('');
    const onChangeForFooterValue=(e)=>{
        console.log('Editable Footer:',e.target.value);
        setFooterValue(e.target.value);
    };
    //trans
    // get translate value
    const [finalTranslateData,setFinalTranslateData] = useState<IAgriAlertTranslateResModel>(null);
    const checkWhetherGetTranslateFromApi = async()=>{
        if(selectedLanguageCode===''){
            const result = await getAgriAlertTranslateValue('en');
            setFinalTranslateData(result);
        }else{
            const result = await getAgriAlertTranslateValue(selectedLanguageCode);
            setFinalTranslateData(result);
        }
    };

    useEffect(()=>{
        if(selectedLanguageCode){
            checkWhetherGetTranslateFromApi();
        }
        if(selectedLanguageCode==='fr'){
            setDateFormat('DD/MM/YYYY');
        }
        else{
            setDateFormat('MM/DD/YYYY');
        }
    },[selectedLanguageCode]);

    console.log('lanxue locationList',locationList);
    return(
        <Spin spinning={loading}>
            <div className="template-edit-container">
                <IF show={selectedTemplateType === TemplateEnumType.EDITTEMPLATE}>
                    <div className='edit-header'>
                        <h2 className='header-title'>Edit Template</h2>
                        <div>
                            <span className='active-style'>Active</span>
                            <Switch defaultChecked checked={isActiveTemplate} disabled={isDisabled}
                                onChange={(value)=>{onChangeforSwitch(value,'template');}} />
                        </div>
                    </div>
                    <div className='edit-bar'>
                        <span className='edit-title'>Edit Template</span>
                    </div>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.CREATETEMPLATE}>
                    <div className='edit-header'>
                        <h2 className='header-title'>Create Template</h2>
                        <div>
                            <span className='active-style'>Active</span>
                            <Switch defaultChecked checked={isActiveTemplate} disabled={isDisabled}
                                onChange={(value)=>{onChangeforSwitch(value,'template');}} />
                        </div>
                    </div>
                    <div className='edit-bar'>
                        <span className='edit-title'>Create Template</span>
                    </div>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.VIEWTEMPLATE}>
                    <div className='edit-header'>
                        <h2 className='header-title'>View Template</h2>
                        <div>
                            <span className='active-style'>Active</span>
                            <Switch defaultChecked checked={isActiveTemplate} disabled={isDisabled}
                                onChange={(value)=>{onChangeforSwitch(value,'template');}} />
                        </div>
                    </div>
                    <div className='view-bar'>
                        <span className='edit-title'>View Template</span>
                    </div>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.SUBSCRIBE}>
                    <div className='edit-header'>
                        <h2 className='header-title'>Subscription</h2>
                    </div>
                    <div className='edit-bar'>
                        <span className='edit-title'>Subscription</span>
                    </div>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.VIEWSUBSCRITION}>
                    <div className='edit-header'>
                        <h2 className='header-title'>View Subscription</h2>
                    </div>
                    <div className='view-bar'>
                        <span className='edit-title'>View Subscription</span>
                    </div>
                </IF>
                <IF show={selectedTemplateType === TemplateEnumType.MODIFYSUBSCRIBE}>
                    <div className='edit-header'>
                        <h2 className='header-title'>Modify Subscription</h2>
                    </div>
                    <div className='edit-bar'>
                        <span className='edit-title'>Modify Subscription</span>
                    </div>
                </IF>
                <div className='content'>
                    <div className='template-name'>
                        <div>
                            <p className='text'><span className='red'>*</span>{nameText} </p>
                        </div>
                        <div style={{width:'70%'}}>
                            <Input placeholder="Enter Name"
                                disabled={isDisabled}
                                value={tempOrSubName}
                                onChange={onChangeForTempOrSubName} />
                        </div>
                    </div>
                    <Divider/>
                    <Form
                        labelCol={{ xs: 8, sm: 4, md: 3, lg: 3,xl:2 }}
                        wrapperCol={{ xs: 21, sm: 20, md: 21, lg: 21, xl:21}}
                        form={form}
                        name="dynamic_form_complex"
                        style={{ width: '100%' }}
                        autoComplete="off"
                        initialValues={{ items: [{}] }}
                    >

                        {/* Location */}
                        <AgriAlertLocation
                            isDisabled = {isDisabled}
                            form={form}
                            selectedTemplateType={selectedTemplateType}
                            locationList={locationList}
                            templateId={templateId}
                            locationCheckFlag = {locationCheckFlag}
                            changeLocationCheckFlag={childChangeLocationCheckFlag}
                            changeLocationListCallback={childChangeLocationListCallback}
                        />
                    </Form>
                    {/* Time zone */}
                    <div className='flex-row'>
                        <div className='time-zone'>
                            <p><span className='red'>*</span>Your Time Zone</p>
                            <Select
                                showSearch
                                size='large'
                                value={timeZoneIdData}
                                disabled={isDisabled}
                                placeholder="Select a Time Zone"
                                onChange={(value) => onChangeForTimeZone(value)}
                                filterOption={(input, option:any) =>{
                                    return(
                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    );}}
                            >
                                {timeZoneList?.map((timezone,index) => (
                                    <Option key={`${timezone.timezoneId}-${index}`} value={timezone.timezoneId}>
                                        {timezone.timezoneName}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className='language'>
                            <p><span className='red'>*</span>Language</p>
                            <Select
                                size='large'
                                placeholder="Select language"
                                disabled={isDisabled}
                                value={selectedLanguageCode}
                                onChange={(value)=>{onChangeForTemOptions(value,'language');}}>
                                {templateOptions?.language?.sort((a,b)=>{
                                    if(a.name < b.name) return -1;
                                    if(a.name > b.name) return 1;
                                    return 0;
                                })?.map((item,index) => (
                                    <Option key={`${item.code}-${index}`} value={item.code}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <div className='flex-row'>
                        <div className='second-line'>
                            <div className='select-frequency'>
                                <p><span className='red'>*</span>Select Frequency</p>
                                <Select
                                    size='large'
                                    disabled={isDisabled}
                                    value={selectedAnOptin}
                                    onChange={onChangeforSelectAnOptin}>
                                    {options2}
                                </Select>
                            </div>
                            <div className='start-date'>
                                <p><span className='red'>*</span>Start Date</p>
                                <DatePicker
                                    disabled={isDisabled}
                                    allowClear
                                    onChange={onChangeForStartDate}
                                    value={selectedStartDate}
                                    format={dateFormat} />
                            </div>
                            <div className='end-date'>
                                <p>End Date</p>
                                <DatePicker
                                    allowClear
                                    onChange={onChangeForEndDate}
                                    value={selectedEndDate}
                                    format={dateFormat} />
                            </div>
                        </div>
                        {/* Select unit */}
                        <div className='unit'>
                            <p><span className='red'>*</span>Unit</p>
                            <Select
                                size='large'
                                placeholder="Select Unit"
                                disabled={isDisabled}
                                value={selectedUnit}
                                onChange={(value)=>{onChangeForTemOptions(value,'unit');}}
                            >
                                <Option key={'metric-1'} value={'metric'}>metric</Option>
                                <Option key={'imperial-1'} value={'imperial'}>imperial</Option>
                            </Select>
                        </div>
                    </div>
                    <div className='flex-row'>
                        {isShowWeekDiv&&(
                            <div className='checkBox-div'>
                                {isShowTip&&(<p className='red'>Please select at least one day from Monday to Sunday </p>)}
                                <Checkbox disabled={isDisabled} checked={selectedDays?.includes('1')} value='1' onChange={(e)=>onChangeForCheckBox(e,'1')}>Monday</Checkbox>
                                <Checkbox disabled={isDisabled} checked={selectedDays?.includes('2')} value='2' onChange={(e)=>onChangeForCheckBox(e,'2')}>Tuesday</Checkbox>
                                <Checkbox disabled={isDisabled} checked={selectedDays?.includes('3')} value='3' onChange={(e)=>onChangeForCheckBox(e,'3')}>Wednesday</Checkbox>
                                <Checkbox disabled={isDisabled} checked={selectedDays?.includes('4')} value='4' onChange={(e)=>onChangeForCheckBox(e,'4')}>Thursday</Checkbox>
                                <Checkbox disabled={isDisabled} checked={selectedDays?.includes('5')} value='5' onChange={(e)=>onChangeForCheckBox(e,'5')}>Friday</Checkbox>
                                <Checkbox disabled={isDisabled} checked={selectedDays?.includes('6')} value='6' onChange={(e)=>onChangeForCheckBox(e,'6')}>Saturday</Checkbox>
                                <Checkbox disabled={isDisabled} checked={selectedDays?.includes('0')} value='0' onChange={(e)=>onChangeForCheckBox(e,'0')}>Sunday</Checkbox>
                            </div>
                        )
                        }
                        <div className='select-time'>
                            <p><span className='red'>*</span>Select Time</p>
                            <Select
                                size="large"
                                value={selectedTime}
                                onChange={handleChangeForTime}
                                options={hourOptions}
                                disabled={isDisabled}
                            />
                        </div>
                    </div>

                    {/* include all edit email content */}
                    <div
                        className={`${(selectedTemplateType === TemplateEnumType.EDITTEMPLATE ||
                            selectedTemplateType === TemplateEnumType.CREATETEMPLATE ||
                            selectedTemplateType === TemplateEnumType.VIEWTEMPLATE) ? 'flex-subs-border' : ''}`}
                    >
                        <IF show = {selectedTemplateType === TemplateEnumType.EDITTEMPLATE ||
                            selectedTemplateType === TemplateEnumType.CREATETEMPLATE ||
                            selectedTemplateType === TemplateEnumType.VIEWTEMPLATE
                        }
                        >
                            <div className='flex-row'
                                style={{display: 'flex',justifyContent: 'flex-end'}}
                            >
                                <span style={{marginRight: '5px'}}>Affect all subscriptions</span>
                                <Switch defaultChecked checked={isActiveControlSubscriptionContent} disabled={isDisabled}
                                    onChange={(value)=>{onChangeforSwitch(value,'controlSubscriptionContent');}} />
                            </div>
                        </IF>
                        <div className='text-div'>
                            <div style={{display:'flex',flexDirection:'row'}}>
                                <span className='red'>*</span>
                                <Input size='large'
                                    disabled={isDisabled}
                                    value={inputSubject}
                                    onChange={onChangeForSubject}
                                    placeholder='Subject' />
                            </div>
                            <Editor
                                defaultConfig={editorConfig}
                                value={html}
                                onCreated={setEditor}
                                onChange={(tmpEdit)=>{
                                    editorOnchange(tmpEdit);
                                }}
                                mode="default"
                                className={isDisabled?'editor-style':''}
                                style={{height: '101px',overflowY: 'hidden'}}
                            />
                            <Toolbar
                                editor={editor}
                                defaultConfig={toolbarConfig}
                                mode="default"
                                style={{borderTop:'1px solid #ccc', borderBottom: '1px solid #ccc' }}
                            />
                        </div>
                        <div className='flex-row-mb'>
                            <div className='one-column' style={{width:'100%',marginTop:'20px'}}>
                                <p>Select Banner</p>
                                <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                    <Select
                                        showArrow
                                        size="large"
                                        className='multiple-select'
                                        disabled={isDisabled}
                                        mode="multiple"
                                        placeholder="Select Banner"
                                        value={selectedBanners}
                                        onChange={handleChangeForBannner}
                                        style={{ width: '100%' }}
                                        filterOption={(input, option:any) =>{
                                            return(
                                                (option?.children[1] ?? '').toLowerCase().includes(input.toLowerCase())
                                            );
                                        }}
                                    >
                                        {banners?.map((banner) => (
                                            <Select.Option
                                                key={banner.bannerId}
                                                value={banner.bannerS3Name}
                                            >
                                                <img
                                                    src={banner.bannerS3URL}
                                                    alt={banner.bannerOriginName}
                                                    style={{ width: '50px', height: 'auto', marginRight: '8px' }}
                                                />
                                                {banner.bannerOriginName}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className='flex-row'>
                            <UploadBanner
                                uploadSuccessCallback={getAllBanner}
                                isDisabled={isDisabled}
                            />
                        </div>
                    </div>



                    <IF show={isTempPage}>
                        {/* Forecast Chart*/}
                        <div className='flex-row-mb'>
                            <div className={isDisabled?'width-mr-view':'width-mr'}>
                                <Collapse activeKey={activeKey6} expandIconPosition="end" className={customClass6}>
                                    <Panel header="Forecast Chart" key="1">
                                        {/* <div className='flex-row'>
                                            <div style={{width:'25%',marginRight:'5%'}}></div>
                                            <div className='one-column'>
                                                <p><span className='red'>*</span>Select Variables</p>
                                                <Select
                                                    disabled={isDisabled}
                                                    className='multiple-select'
                                                    size='large'
                                                    placeholder="Select Variables"
                                                    mode="multiple"
                                                    value={selectedForecastChartVariables}
                                                    onChange={(value)=>{onChangeForTemOptions(value,'forecastChartVariables');}}
                                                >
                                                    {templateOptions?.forecastWeatherChartVariables?.
                                                        sort((a,b)=>{
                                                            if(a.name < b.name) return -1;
                                                            if(a.name > b.name) return 1;
                                                            return 0;
                                                        }).
                                                        filter(x => x?.forecast_request_code!== 'WindDirection_DailyAvg')?.
                                                        map((item,index) => (
                                                            <Option key={`${item.code}-${index}`} value={item.forecast_request_code}>
                                                                {item.name}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </div>
                                        </div> */}

                                        <ForecastChartSelect
                                            templateOptions={templateOptions}
                                            isDisabled = {isDisabled}
                                            type= {ChartsOrTablesEnum.CHARTS}
                                            selectedForecast={selectedForecastCharts}
                                            childChangeSelectedForecast={childChangeSelectedForecastCharts}
                                        />
                                    </Panel>
                                </Collapse>
                            </div>
                            <div className='switch-style'>
                                <Switch defaultChecked checked={isActiveForecastChart} disabled={isDisabled}
                                    onChange={(value)=>{onChangeforSwitch(value,'forecastChart');}} />
                            </div>
                        </div>

                        {/* Forecast Table - Daily Resolution */}
                        <div className='flex-row-mb'>
                            <div className={isDisabled?'width-mr-view':'width-mr'}>
                                <Collapse activeKey={activeKey5} expandIconPosition="end" className={customClass5}>
                                    <Panel header="Forecast Table" key="1">
                                        <ForecastTableSelect
                                            templateOptions={templateOptions}
                                            isDisabled = {isDisabled}
                                            type= {ChartsOrTablesEnum.TABLES}
                                            selectedForecast={selectedForecastTables}
                                            childChangeSelectedForecast={childChangeSelectedForecastTable}
                                        />
                                        {/* <div className='flex-row'>
                                            <div style={{width:'25%',marginRight:'5%'}}></div>
                                            <div className='one-column' style={{width:'70%'}}>
                                                <p><span className='red'>*</span>Select Variables</p>
                                                <Select
                                                    disabled={isDisabled}
                                                    className='multiple-select'
                                                    size='large'
                                                    placeholder="Select Variables"
                                                    mode="multiple"
                                                    value={selectedForecastTableDailyVariables}
                                                    onChange={(value)=>{onChangeForTemOptions(value,'forecastTableDailyVariables');}}
                                                >
                                                    {templateOptions?.forecastWeatherChartVariables?.
                                                        sort((a,b)=>{
                                                            if(a.name < b.name) return -1;
                                                            if(a.name > b.name) return 1;
                                                            return 0;
                                                        }).
                                                        map((item,index) => (
                                                            <Option key={`${item.code}-${index}`} value={item.forecast_request_code}>
                                                                {item.name}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </div>
                                        </div> */}
                                    </Panel>
                                </Collapse>
                            </div>
                            <div className='switch-style'>
                                <Switch defaultChecked checked={isActiveForecastTable} disabled={isDisabled}
                                    onChange={(value)=>{onChangeforSwitch(value,'forecastTableDaily');}} />
                            </div>
                        </div>

                        {/* Forecast Table - Hourly Resolution*/}
                        {/* <div className='flex-row-mb'>
                            <div className={isDisabled?'width-mr-view':'width-mr'}>
                                <Collapse activeKey={activeKey7} expandIconPosition="end" className={customClass7}>
                                    <Panel header="Forecast Table - Hourly Resolution" key="1">
                                        <div className='flex-row'>
                                            <div style={{width:'25%',marginRight:'5%'}}></div>
                                            <div className='one-column' style={{width:'70%'}}>
                                                <p><span className='red'>*</span>Select Variables</p>
                                                <Select
                                                    disabled={isDisabled}
                                                    className='multiple-select'
                                                    size='large'
                                                    placeholder="Select Variables"
                                                    mode="multiple"
                                                    value={selectedForecastTableHourlyVariables}
                                                    onChange={(value)=>{onChangeForTemOptions(value,'forecastTableHourlyVariables');}}
                                                >
                                                    {templateOptions?.forecastWeatherTableHourlyVariables?.
                                                        sort((a,b)=>{
                                                            if(a.name < b.name) return -1;
                                                            if(a.name > b.name) return 1;
                                                            return 0;
                                                        }).
                                                        map((item,index) => (
                                                            <Option key={`${item.code}-${index}`} value={item.forecast_request_code}>
                                                                {item.name}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </div>
                                        </div>
                                    </Panel>
                                </Collapse>
                            </div>
                            <div className='switch-style'>
                                <Switch defaultChecked checked={isActiveForecastTableHourly} disabled={isDisabled}
                                    onChange={(value)=>{onChangeforSwitch(value,'forecastTableHourly');}} />
                            </div>
                        </div> */}

                        {/* Agronomic Recommendations */}
                        <div className='flex-row-mb self-agronomic'>
                            <div className={isDisabled?'width-mr-view':'width-mr'}>
                                <Collapse activeKey={activeKey8} expandIconPosition="end" className={customClass8}>
                                    <Panel style={{border:'none'}} header="Agronomic Recommendations" key="1">
                                        <div className='flex-row'>
                                            <AgronomicRecommendations
                                                templateOptions={templateOptions}
                                                dateFormat={dateFormat}
                                                selectedAgronomic={selectedAgronomic}
                                                initFlag = {initFlag}
                                                childChangeSelectedAgronomic={childChangeSelectedAgronomic}
                                                childChangeInitFlag={childChangeInitFlag}
                                            />
                                        </div>
                                    </Panel>
                                </Collapse>
                            </div>
                            <div className='switch-style'>
                                <Switch defaultChecked checked={isActiveAgronomic} disabled={isDisabled}
                                    onChange={(value)=>{onChangeforSwitch(value,'agronomic');}} />
                            </div>
                        </div>

                        {/* Historical Chart */}
                        <div className='flex-row-mb remove-padding'>
                            <div className={isDisabled?'width-mr-view':'width-mr'}>
                                <Collapse activeKey={activeKey2} expandIconPosition="end" className={customClass2}>
                                    <Panel style={{border:'none'}} header="Historical Chart" key="1">
                                        <div className='flex-row'>
                                            <HistoricalChartSelect
                                                templateOptions={templateOptions}
                                                isDisabled = {isDisabled}
                                                selectedHistoricalCharts={selectedHistoricalCharts}
                                                childChangeSelectedHistoricalCharts={childChangeSelectedHistoricalCharts}
                                            />
                                        </div>
                                    </Panel>
                                </Collapse>
                            </div>
                            <div className='switch-style'>
                                <Switch defaultChecked checked={isActiveHistorical} disabled={isDisabled}
                                    onChange={(value)=>{onChangeforSwitch(value,'historical');}} />
                            </div>
                        </div>
                    </IF>
                    <Divider />
                    <div className='footer-information' >
                        <div className='editable-footer'>
                            <p>{finalTranslateData?.footer_edit}: {finalTranslateData?.footer_options}</p>
                            <TextArea
                                rows={1}
                                value={footerValue}
                                onChange={onChangeForFooterValue}
                                allowClear>
                            </TextArea>
                        </div>
                        <div className='mandatory-footer'>
                            <p>{finalTranslateData?.footer_mandatory}</p>
                            <table>
                                <tr>
                                    <td>{finalTranslateData?.footer_copyright}.</td>
                                </tr>
                                <tr>
                                    <td>{finalTranslateData?.footer_service}
                                        <a style={{marginLeft:'3px'}} title='https://www.meteoblue.com/' className='strong-text'
                                            href='https://www.meteoblue.com/'>{finalTranslateData?.footer_meteoblue}
                                        </a>.
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p className='strong-text'>
                                            {finalTranslateData?.footer_data}
                                        </p>
                                        {finalTranslateData?.footer_content}.
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p className='strong-text'>
                                            {finalTranslateData?.footer_click_content}
                                            <a style={{margin:'0 3px'}} title='mailto:pradeep.kethireddy@syngenta.com?subject=Remove my email-id from the report'
                                                href='mailto:pradeep.kethireddy@syngenta.com?subject=Remove my email-id from the report'>
                                                {finalTranslateData?.footer_here}
                                            </a>{finalTranslateData?.footer_unsubscribe}.
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <Divider />
                    <div className='operation-div'>
                        <IF show={selectedTemplateType === TemplateEnumType.EDITTEMPLATE}>
                            <div className='left'>
                                <button className='delete-button'
                                    onClick={deleteBtn}>
                                Delete
                                </button>
                            </div>
                        </IF>
                        <div className='right'>
                            <button className='edit-button'
                                onClick={cancelBtn}>
                                Cancel
                            </button>
                            <button className='download-button' onClick={showPreview}>
                                Preview
                            </button>
                            <IF show={selectedTemplateType === TemplateEnumType.CREATETEMPLATE}>
                                <Button className='download-button' htmlType="submit"
                                    onClick={addTemplateData}
                                >
                            Save
                                </Button>
                            </IF>
                            <IF show={selectedTemplateType === TemplateEnumType.EDITTEMPLATE}>
                                <button className='download-button' onClick={saveTemplateData}>
                            Save
                                </button>
                            </IF>
                            <IF show={selectedTemplateType === TemplateEnumType.SUBSCRIBE}>
                                <Button className='download-button' htmlType="submit"
                                    onClick={addSubScriptionData}
                                >
                            Save
                                </Button>
                            </IF>
                            <IF show={selectedTemplateType === TemplateEnumType.MODIFYSUBSCRIBE}>
                                <Button className='download-button' htmlType="submit"
                                    onClick={modifiedSubcription}
                                >
                            Save
                                </Button>
                            </IF>
                        </div>
                    </div>
                </div>
                <IF show={isShowPreview}>
                    <TemplatePreview
                        editableFooterContent={footerValue}
                        modalOpen={isShowPreview}
                        title="Agri-Alert-Template_2024-07-12"
                        changeModalOpenCallback={childChangeShowPreview}
                    />
                </IF>

            </div>
        </Spin>
    );
};

export default TemplateEdit;